import React from "react";
import { withCartIdParam } from "../../../../utils/BrowserHelper";
import { LightBoxViewCartIcon } from "../vectors/AddToCartIcon";

interface ViewCartLinkProps {
  cartId: number;
  isEmbed: boolean;
  parentName: string | null;
  primaryColor: string;
}

const ViewCartLink: React.FC<ViewCartLinkProps> = ({
  cartId,
  isEmbed,
  parentName,
  primaryColor
}) => (
  <a
    href={withCartIdParam(`/checkout?source=${parentName}`, cartId, isEmbed)}
    target={isEmbed ? "_blank" : undefined}
    rel={isEmbed ? "noopener noreferrer" : undefined}
    style={{
      border: `1px solid ${primaryColor}`,
      color: primaryColor
    }}
    className="geo-btn view-cart-btn"
  >
    <LightBoxViewCartIcon color={primaryColor} />
    <span>&nbsp; View cart</span>
  </a>
);

export default ViewCartLink;
